import CallStatusMappingsTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallStatusMappingsTable
  },
  data() {
    return {
      callStatusMappings: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle('Listado de codificaciones')
    this.$setBreadcrumbs([
      { label: 'Codificaciones', route: {} }
    ])
  },
  methods: {
    loadMappings(params = {}) {
      API.callStatusMappings.index(params).then(({data, meta}) => {
        this.callStatusMappings = data
        this.meta = meta
      }).catch(error => {
        console.error("Error cargando codificaciones en API:", error)
      })
    }
  }
})